import TopCompanies from './TopCompanies';

export default TopCompanies;
